import { Card, CardContent, Typography, Box } from "@mui/material";
import {
  Truck,
  Package,
  BarChart3,
  Clock,
  FileSpreadsheet,
  Activity,
  DollarSign,
} from "lucide-react";

const ICONS = {
  "Full Logistics Management": Truck,
  "Accounting, Finance & Payment Management": FileSpreadsheet,
  "Automated Tracking & Fast Payments": Activity,
  "Industry-Leading Pricing & Payouts": DollarSign,
};

export default function ServiceCard({ title, description }) {
  const Icon = ICONS[title] || Package;

  return (
    <Card
      sx={{
        height: "100%",
        bgcolor: "background.black_shade_secondary",
        color: "text.primary",
        borderRadius: "10px",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-5px)",
        },
      }}
    >
      <CardContent>
        <Box sx={{ mb: 2, color: "primary.main" }}>
          <Icon size={40} />
        </Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}
